import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

function ProtectedRoute({ children, component: Component, ...rest }) {
  const user = useSelector((state) => state.auth.user);

  // When user is empty, save the original path name, then redirect to login page
  if (!user) {
    // console.log('redirected', rest)

    localStorage.setItem('originalPathName', JSON.stringify(rest.location));
    // const check = localStorage.getItem('originalPathName');
    // console.log('check before redirected', check);
    return <Redirect to={'/login'} />;
  }

  // When user is not empty, check the original path name, indicating it's just being redirected
  const originalPathName = localStorage.getItem('originalPathName');
  if (originalPathName) {
    // console.log('original path', originalPathName, JSON.parse(originalPathName));
    localStorage.removeItem('originalPathName');
    return <Redirect to={JSON.parse(originalPathName)} />;
  }

  // When there's no redirection occurs, continue as requested
  return <Route {...rest} component={Component} />;
}

export default ProtectedRoute;
